module.exports = __webpack_public_path__ + "static/media/drone.1cf1106e.png";